<template>
    <v-card>
        <v-card-title>Search Form</v-card-title>
        <v-card-subtitle>Empty fields will be ignored.</v-card-subtitle>
        <v-form ref="multiSearchForm">
            <v-card-text class="pt-0">
                <v-container
                    class="py-0"
                    fluid
                >
                    <v-row>
                        <v-col
                            :key="index"
                            cols="12"
                            v-for="(inputField, index) in inputFields"
                        >
                            <v-text-field
                                :label="inputField.display"
                                v-model="inputField.value"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            @click="search"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Search</v-btn>
                        <v-btn
                            @click="reset"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Reset</v-btn>
                        <v-btn
                            @click="close"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
export default {
    props: {
        fields: Array
        //[ {display, property}, {display, property}]
    },
    mounted: function() {
        this.inputFields = this.fields.map(function(x) {
            return {
                display: x.display,
                property: x.property,
                value: x.value ?? ""
            };
        });
    },
    components: {
        //
    },
    data() {
        return {
            inputFields: []
        };
    },

    methods: {
        //emitters      ------------------------------------------------------------
        search() {
            //build search output and emit
            this.$emit(
                "search",
                this.inputFields
                    //.filter(x => x.value != "" && x.value != null)
                    .map(function(x) {
                        return { display: x.display, property: x.property, value: x.value };
                    })
            );
        },
        reset() {
            //build empty search output and emit
            this.inputFields.forEach(x => (x.value = ""));
            this.$emit("search", []);
        },
        close() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="stylus" scoped></style>